const priceMonth = 9;
const priceYear = 87;

export default function buildPrice(count, plan) {
  if (plan === 'monthly') {
    switch (count) {
      case 1:
        return priceMonth;
      case 2:
        return priceMonth + priceMonth * 0.75;
      case 3:
        return priceMonth + priceMonth * 0.75 + priceMonth * 0.5;
      default:
        if (count > 3) {
          return (
            priceMonth +
            priceMonth * 0.75 +
            priceMonth * 0.5 +
            (count - 3) * priceMonth * 0.25
          );
        } else {
          return priceMonth;
        }
    }
  } else if (plan == 'annually') {
    switch (count) {
      case 1:
        return priceYear;
      case 2:
        return priceYear + priceYear * 0.75;
      case 3:
        return priceYear + priceYear * 0.75 + priceYear * 0.5;
      default:
        if (count > 3) {
          return (
            priceYear +
            priceYear * 0.75 +
            priceYear * 0.5 +
            (count - 3) * priceYear * 0.25
          );
        } else {
          return priceYear;
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/buildPrice.js